'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _requestStarted = require('conversations-internal-schema/async-data/operators/requestStarted');

var _requestSucceeded = require('conversations-internal-schema/async-data/operators/requestSucceeded');

var _requestFailed = require('conversations-internal-schema/async-data/operators/requestFailed');

var _AsyncData = require('conversations-internal-schema/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionTypes = (0, _makeRequestActionTypes.makeRequestActionTypes)(_actionTypes.CREATE_NEW_THREAD);
var initialState = (0, _AsyncData2.default)();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, actionTypes.STARTED, _requestStarted.requestStarted), _defineProperty(_handleActions, actionTypes.SUCCEEDED, _requestSucceeded.requestSucceeded), _defineProperty(_handleActions, actionTypes.FAILED, _requestFailed.requestFailed), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/reducers/createThreadStatus.js
// module id = 1280
// module chunks = 3